// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodIdQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET payroll endpoints that read period_id from the query
 * string.
 *
 * period_id is nullable so the controller keeps its existing
 * "period_id obrigatório" guard (preserving the legacy error message).
 *
 * Used by:
 * - GET /payroll/executions?period_id=X
 */
import { registerContract } from './validate'

export interface Payroll_PeriodIdQueryInput {
period_id?: number
}

registerContract('Payroll_PeriodIdQueryInput', {
  period_id: { type: 'number',  required: false },
})
